export default __webpack_public_path__ + "static/LogoConferenceBuddy-c1e9db1c68f131fb078295e83d6cb846.png";